var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactDatePicker from 'react-datepicker';
import { StyledDatePicker } from './styles';
import { InputBorder } from '../InputBorder';
export var DatePicker = function (_a) {
  var error = _a.error,
    onChange = _a.onChange,
    variant = _a.variant,
    _b = _a.inputWidth,
    inputWidth = _b === void 0 ? '100%' : _b,
    props = __rest(_a, ["error", "onChange", "variant", "inputWidth"]);
  switch (variant) {
    case 'inline-range':
      return _jsx(StyledDatePicker, {
        variant: "inline-range",
        inputWidth: inputWidth,
        children: _jsx(ReactDatePicker, __assign({
          "data-cy-label": "datepicker",
          dateFormat: 'dd/MM/yyyy',
          inline: true,
          monthsShown: 2,
          onChange: onChange,
          selectsRange: true,
          shouldCloseOnSelect: false,
          showPopperArrow: false
        }, props))
      });
    case 'inline-range-compact':
      return _jsx(StyledDatePicker, {
        variant: "inline-range-compact",
        inputWidth: inputWidth,
        children: _jsx(ReactDatePicker, __assign({
          "data-cy-label": "datepicker",
          dateFormat: 'dd/MM/yyyy',
          inline: true,
          onChange: onChange,
          selectsRange: true,
          shouldCloseOnSelect: false,
          showPopperArrow: false
        }, props))
      });
    case 'input':
    default:
      return _jsx(InputBorder, {
        style: {
          width: inputWidth
        },
        error: error,
        "data-cy-label": "datepicker",
        children: _jsx(StyledDatePicker, {
          variant: "input",
          inputWidth: inputWidth,
          children: _jsx(ReactDatePicker, __assign({
            "data-cy-label": "react-date-picker",
            onChange: onChange,
            showPopperArrow: false
          }, props))
        })
      });
  }
};